import { statusTone } from "../format";

interface Props {
  options: string[];
  hints?: string[]; // descrição curta por opção, mesmo índice de `options`
  value?: string;
  onChange: (v: string) => void;
}

/** Seletor de status em cards coloridos (ponto + rótulo + descrição) — usado
 * sempre que o usuário escolhe entre valores de status/resultado, no lugar de
 * um <select> simples. A cor de cada card vem da mesma regra das pílulas da
 * tabela (statusTone), então os dois ficam sempre consistentes. */
export default function StatusCardSelector({ options, hints, value, onChange }: Props) {
  return (
    <div className="status-selector">
      {options.map((opt, i) => {
        const tone = statusTone(opt);
        return (
          <button
            key={opt}
            type="button"
            className={`status-card status-card-${tone}${value === opt ? " active" : ""}`}
            onClick={() => onChange(opt)}
          >
            <span className="status-card-head">
              <span className="status-card-dot" />
              <span className="status-card-label">{opt}</span>
            </span>
            {hints?.[i] && <span className="status-card-desc">{hints[i]}</span>}
          </button>
        );
      })}
    </div>
  );
}
